<p-confirmDialog />

<div class="gap-3 d-flex flex-column h-100">
  @if (!hasGridData()) {
    <!-- Empty State -->
    <div class="bg-gray-100 d-flex align-items-center justify-content-center h-100 rounded-4">
      <div class="text-center text-muted">
        <p class="mb-3 fs-16">
          No lots or models yet. Add lots and assign models to the project, then upload siting analysis to see the
          mapping.
        </p>
      </div>
    </div>
  } @else {
    <!-- Lots under Lot Code, models under Models, mapping from sitingAnalysis -->
    <div class="d-flex flex-column h-100">
      <div class="flex-wrap d-flex align-items-center">
        <div
          class="flex-wrap gap-3 p-3 py-2 mb-3 d-flex align-items-center align-self-baseline ms-1 bg-light rounded-3"
        >
          <div class="gap-2 d-flex align-items-center">
            <span class="text-success fs-15 fw-500">O</span>
            <span class="text-success">Compatible</span>
            <span
              class="align-items-center bg-success-subtle text-success d-flex fs-14 justify-content-center rounded-5 wh-20 d-none"
              >2</span
            >
          </div>
          <span class="vr"></span>
          <div class="gap-2 d-flex align-items-center">
            <span class="text-danger fs-15 fw-500">X</span>
            <span class="text-danger">Incompatible</span>
            <span
              class="align-items-center bg-danger-subtle text-danger d-flex fs-14 justify-content-center rounded-5 wh-20 d-none"
              >8</span
            >
          </div>
        </div>
        <div class="ms-auto">
          <input #fileInput type="file" class="d-none" accept=".csv,.xlsx,.xls" (change)="onFileSelected($event)" />
          <div class="flex-wrap gap-3 mb-3 d-flex align-items-center justify-content-end">
            <button type="button" class="btn btn-outline-secondary btn-h42" (click)="onExportClick()">
              <i class="bi bi-download me-1"></i>
              Export
            </button>
            <button class="btn btn-primary btn-h42" (click)="onImportClick()">
              <i class="bi bi-{{ hasGridData() ? 'arrow-clockwise' : 'upload' }} me-1"></i>
              {{ hasGridData() ? 'Re import' : 'Import' }}
            </button>
            <!-- <a href="https://filemanager-bucket-public.s3.ca-central-1.amazonaws.com/shared/Siting+Analysis+Sample+File.xlsx"
  download class="btn btn-h42 btn-outline-success">
  <i class="bi bi-file-earmark-spreadsheet fs-20"></i>
  Sample File
</a> -->
            <!-- <button class="btn btn-primary btn-h42 ms-auto" (click)="onExportClick()">
  <i class="bi bi-download me-2"></i>
  Export
</button> -->
          </div>
        </div>
      </div>
      <div class="table-outer table-theme flex-fill siting-models-table">
        <div class="table-responsive h-100">
          <p-table
            [className]="'table-prime'"
            [value]="tableData()"
            dataKey="lotId"
            [scrollable]="true"
            [rowHover]="true"
            styleClass="p-datatable-striped"
          >
            <ng-template #header>
              <tr>
                <th class="sticky-col text-center" rowspan="2" [width]="200">Lot Code</th>
                <th class="text-center" [attr.colspan]="columns().length">Models / Elevations</th>
              </tr>
              <tr>
                @for (column of columns(); track column.key) {
                  <th class="text-center">{{ column.label }}</th>
                }
              </tr>
            </ng-template>
            <ng-template #body let-row>
              <tr>
                <td class="sticky-col fw-bold lot-code-cell">{{ row.lotNo }}</td>
                @for (column of columns(); track column.key) {
                  <td
                    class="text-center fw-bold"
                    [class.text-success]="row[column.key] === 'O'"
                    [class.text-danger]="row[column.key] === 'X'"
                  >
                    {{ row[column.key] }}
                  </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }
</div>
